// extracted by mini-css-extract-plugin
export default {"container":"LQpUqV","date":"v2vbgt","location":"xtenVZ","divider":"yL_0IY","alignment":"wu0Sg9"};